/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useNavigate, useParams, useLocation  } from "react-router";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, SelectEquipment, CustomLoading, Breadcrumb, Modal, Calendar, InputCheckbox, InputRadio } from "../../../Components/index.js";
import { Graph } from "../Components/index.js";

/* 🔗 SERVICE */
import { HistoricServices } from "../../../Services/historicosServices/index.js";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store/index.js";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeHistoricLoading, changeHistoricLoadingList, changeModal } from "../../../Redux/Actions/index.js";

/* 📁 ASSETS*/
import { Download } from "../../../Assets/icons";

/* 🎨 STYLES */
import { HeaderContainer, BodyContainer, ContainerTable, Table, TableHeader, 
    TableRow, TableCell, ContainerSpinner, NoData, TableCellItem, GraphContainer, 
    ButtonDownload, DownloadiconContainer} from "./styles";
import { Container } from "../../styles.js";
import { CalendarContainer, OptionsContainer, ButtonsContainer, WarningText, ImageIcon, Subtitle } from "../../Dashboards/Equipamento/styles.js";

/* 🔧 UTILS */
import { isValidStartData, isValidEndData } from "../../../util/validate.js";

const HistoricOnlyAnalysis = () => {
    const { t } = useTranslation();

    document.title = t("reports.sub-items.history.only-analysis.document-title");
    const { id } = useParams();

    const navigationFlow =  [
        { text: 'reports', page: null },
        { text: 'history', page: `/historico/${id}` },
        { text: 'analyses', page: null },
    ];

    const downloadMethods = [
        {id: 'legacy', label: t("input-radio.legacy")},
        {id: 'newStandard', label: t("input-radio.new-standard")}
    ];

    const downloadExtensions = [
        {id: 'xlsx', label: '.xlsx'},
        {id: 'ods', label: '.ods'},
        {id: 'csv', label: '.csv'},
        {id: 'xls', label: '.xls'},
        {id: 'tsv', label: '.tsv'},
        {id: 'pdf', label: '.pdf'},
        {id: 'html', label: '.html'}
    ];

    const navigate = useNavigate();
    const location = useLocation();

    let data1 = location.state?.data1;
    let data2 = location.state?.data2;
    
    const services = useRef(new HistoricServices());
    const analysisMode = useRef(true);
    const readingMode = useRef(false);
    const method = useRef(downloadMethods[1].id);
    const extension = useRef(downloadExtensions[0].id);

    const analysisData = useSelector(state => state.HistoricReducer.analysisData);
    const isLoading = useSelector(state => state.HistoricReducer.isLoading);
    const equipaments = useSelector(state => state.HistoricReducer.equipamentList);
    const Cities = useSelector(state => state.HistoricReducer.cities);
    const city = useSelector(state => state.HistoricReducer.city);
    
    const [datainicio, setDatainicio] = useState(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10)+'T00:00');
    const [datafim, setDatafim] = useState(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10)+'T23:59:59');
    const [isHover, setIsHover] = useState(false);
    const [selectedMethod, setSelectedMethod] = useState(method.current);
    const [selectedMode, setSelectedMode] = useState(null);
    
    function formatarDataParaYMDHMS(data) {
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function formatarDataParaMDHMS(data) {
        let newdata = new Date(data)
        const month = String(newdata.getMonth() + 1).padStart(2, '0');
        const day = String(newdata.getDate()).padStart(2, '0');
        const hours = String(newdata.getHours()).padStart(2, '0');
        const minutes = String(newdata.getMinutes()).padStart(2, '0');
        
        return `${day}/${month} - ${hours}:${minutes}`;
    }
    
    async function getData(){
        store.dispatch(changeModal(''));
        store.dispatch(changeHistoricLoading(true));
        let startData = formatarDataParaYMDHMS(new Date(datainicio));
        let endData = formatarDataParaYMDHMS(new Date(datafim));
        await services.current.getAnalysisData(id, startData, endData);
        store.dispatch(changeHistoricLoading(false));
        store.dispatch(changeHistoricLoadingList(false));
    }

    useEffect(() => {
        services.current.getPocos();
        services.current.getCities();
    }, []);

    useEffect(() => {
        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            setTimeout(() => {
                services.current.changeCity(id);
            }, 6000);
        }
    },[id]);

    useEffect(() => {
        async function getData(){
            store.dispatch(changeModal(''));
            store.dispatch(changeHistoricLoading(true));
            let startData = formatarDataParaYMDHMS(new Date(data1 ? data1 : new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10) + 'T00:00'));
            let endData = formatarDataParaYMDHMS(new Date(data2 ? data2 : new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 16)));
            await services.current.getAnalysisData(id, startData, endData);
            store.dispatch(changeHistoricLoading(false));
            store.dispatch(changeHistoricLoadingList(false));
        }

        if(id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined'){
            getData();
        }
    }, [id, data1, data2, t]);

    return (
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <HeaderContainer $top>
                    <div className="selects">
                        <SelectEquipment Color={'white'} options={Cities} value={city} onChange={(e) => services.current.filterEquipaments(e.target.value)} />
                        <SelectEquipment Color={'white'} options={equipaments} value={id} onChange={(e) => {
                            if(e.target.value === '' || e.target.value === null || e.target.value === undefined){
                                toast(t("message.select-equipment"), {
                                    position: "top-center",
                                    type: 'info',
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                                return
                            }else{
                                services.current.changeCity(e.target.value);
                                navigate(`/historico/analises/${e.target.value}`, {state: {data1: datainicio, data2: datafim}});
                            }
                        }} />
                    </div>
                    <div className="buttons-container">
                        <Button width={'fit-content'} text={t("buttons.general-overview")} onClick={()=>{
                            navigate(`/historico/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                        <Button width={'fit-content'} text={'Detalhar'} onClick={()=>{
                            navigate(`/historico/detalhes/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                        <Button width={'fit-content'} text={'Modo de operação'} onClick={()=>{
                            navigate(`/historico/operacao/${id}`, {state: {data1: datainicio, data2: datafim}})}}></Button>
                    </div>
                </HeaderContainer>

                <HeaderContainer>
                    <div>
                        <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datainicio' 
                            name='datainicio' 
                            type="datetime-local" 
                            placeholder= {t("inputs.initial-date.placeholder")}
                            value={datainicio}
                            max={datafim}
                            // innerRef={UserField}
                            invalidMessage = {t("inputs.initial-date.invalid-message")}
                            validationFunction = {(text) => isValidStartData(text, datafim)}
                            onchange={(text) => text && setDatainicio(text)}> 
                        </Input>
                    </div>
                    <div>
                        <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datafim' 
                            name='datafim' 
                            type="datetime-local" 
                            placeholder= {t("inputs.final-date.placeholder")}
                            value={datafim}
                            min={datainicio}
                            invalidMessage = {t("inputs.final-date.invalid-message")}
                            validationFunction = {(text) => isValidEndData(datainicio, text)}
                            onchange={(text) => (text && !isNaN(new Date(text).getTime())) && setDatafim(text)}> 
                        </Input>
                    </div>
                    <div className="buttons-container">
                        <Button text={t("buttons.apply")} width={'fit-content'} color={'green'} onClick={() => getData()}/>
                        <ButtonDownload $width={'fit-content'} $color={'green'} 
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            onClick={() => store.dispatch(changeModal('reports'))}
                        >
                            <DownloadiconContainer src={Download} fill={isHover ? '#FFF' : ''}/>
                        </ButtonDownload>
                    </div>
                </HeaderContainer>

                <BodyContainer>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    : id !== null && id !== undefined && id !== '' && id !== 'null' && id !== 'undefined' &&
                    <>
                        {analysisData?.AL1?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.analyzer")} 1</NoData>
                                </ContainerSpinner>
                                {analysisData.AL1.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.AL1.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.AL1.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.AL1.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.analyzer")} 1</NoData>
                            </ContainerSpinner>
                        }

                        {analysisData?.AL2?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.analyzer")} 2</NoData>
                                </ContainerSpinner>
                                {analysisData.AL2.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.AL2.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.AL2.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.AL2.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) :
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.analyzer")} 2</NoData>
                            </ContainerSpinner>
                        }

                        {analysisData?.AL3?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.analyzer")} 3</NoData>
                                </ContainerSpinner>
                                {analysisData.AL3.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.AL3.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.AL3.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.AL3.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.analyzer")} 3</NoData>
                            </ContainerSpinner>
                        }

                        {analysisData?.AL4?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.analyzer")} 4</NoData>
                                </ContainerSpinner>
                                {analysisData.AL4.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.AL4.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.AL4.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.AL4.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.analyzer")} 4</NoData>
                            </ContainerSpinner>
                        }

                        {analysisData?.AL5?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.analyzer")} 5</NoData>
                                </ContainerSpinner>
                                {analysisData.AL5.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.AL5.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.AL5.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.AL5.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.analyzer")} 5</NoData>
                            </ContainerSpinner>
                        }

                        {analysisData?.ph?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.pH-meter")}</NoData>
                                </ContainerSpinner>
                                {analysisData.ph.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.ph.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.ph.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.ph.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.pH-meter")}</NoData>
                            </ContainerSpinner>
                        }

                        {analysisData?.sensor?.table?.data?.length > 0 ?
                            <>
                                <ContainerSpinner>
                                    <NoData>{t("reports.sub-items.history.only-analysis.data.sensor")}</NoData>
                                </ContainerSpinner>
                                {analysisData.sensor.graphs.map((graph, index) => (
                                    <GraphContainer key={index}>
                                        <NoData>
                                            {graph[0].id}
                                        </NoData>
                                        <Graph data={JSON.parse(JSON.stringify(graph))}/>
                                    </GraphContainer>
                                ))}
                                <ContainerTable>
                                    <Table>
                                        <thead>
                                            <TableRow>
                                                {analysisData.sensor.table.titles.map((item, index) => (
                                                    <TableHeader key={index}>{item}</TableHeader>
                                                ))}
                                            </TableRow>
                                        </thead>
                                        <tbody>
                                                {analysisData.sensor.table.data.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {analysisData.sensor.table.titles.map((title, index) => (
                                                            <TableCell key={index}>
                                                                <TableCellItem $alarm={item.Alarms[title]}>
                                                                    {title === 'Horário' || title === 'horario' || title === 'Time' ? formatarDataParaMDHMS(item.Values[title]) : 
                                                                    parseFloat(item.Values[title]) ? parseFloat(item.Values[title]).toFixed(2) : item.Values[title]}
                                                                </TableCellItem>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                        </tbody>
                                    </Table>
                                </ContainerTable>
                            </>
                        :
                            <ContainerSpinner>
                                <NoData>{t("reports.sub-items.history.only-analysis.no-data.sensor")}</NoData>
                            </ContainerSpinner>
                        }
                    </>}
                </BodyContainer>
            </Container>
            <Modal title={t("modal.download.title")} id={"report-modal"} name={'reports'} width={'780px'} height={'90%'}>                
                <CalendarContainer>
                    <Calendar title={t("calendar.title.initial-date")}  selectedDate={datainicio} onDateChange={(date) => setDatainicio(date.toISOString().slice(0, 10) + "T00:00")} />
                    <Calendar title={t("calendar.title.final-date")} selectedDate={datafim} onDateChange={(date) => setDatafim(date.toISOString().slice(0, 10) + "T23:59:59")}/>
                </CalendarContainer>
                <OptionsContainer>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.setup-file")}:</Subtitle>
                        <div className="file-setup">
                            <InputCheckbox text={t("checkbox.analysis-mode")} checked={analysisMode.current} onChange={(value) => {analysisMode.current = value; return true}}/>
                            <InputCheckbox text={t("checkbox.reading-mode")} checked={readingMode.current} disabled={selectedMethod === downloadMethods[0].id} onChange ={(value) => {readingMode.current = value; setSelectedMode(value); return true}}/>
                        </div>
                        {selectedMode &&
                            <WarningText $float={'right'}>
                                *{t("modal.report.warnings.option-not-available")}
                            </WarningText>
                        }
                    </div>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.spreadsheet-type")}:</Subtitle>
                        <div className="spreadsheet-setup">
                            <InputRadio name={'method'} options={downloadMethods} value={downloadMethods[1].id} 
                            onChange ={(value) => {method.current = value; setSelectedMethod(value); return true}}/>
                        </div>
                    </div>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.format")}:</Subtitle>
                        <div className="file-format">
                            <InputRadio name={'format'} options={downloadExtensions} value={downloadExtensions[0].id} disabled={selectedMethod === downloadMethods[0].id ? [1, 2, 3, 4, 5, 6] : (selectedMode ? [5, 6] : [])} onChange={(value) => {extension.current = value; return true}}/>
                        </div>
                        {selectedMethod === downloadMethods[0].id &&
                            <WarningText $float={'right'}>
                                *{t("modal.report.warnings.compatible-format")}
                            </WarningText>
                        }
                        
                    </div>
                </OptionsContainer>

                <ButtonsContainer $justify={'space-between'} $sendToEmail={(((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45 && (selectedMethod !== downloadMethods[0].id))}>
                    <Button 
                        text={t("buttons.send-by-email")} 
                        color={"green"} 
                        icon={<ImageIcon className={"icon"} src={Download} fill={"green"}/>} 
                        width={'220px'} 
                        onClick={() => {
                            const startDate = `${new Date(datainicio).toISOString().slice(0, 10)}T00:00`;
                            const endDate = `${new Date(datafim).toISOString().slice(0, 10)}T23:59:59`;
                            const methodOld = method.current === 'legacy';
                            
                            services.current.getExcel(
                                id,
                                startDate,
                                endDate,
                                analysisMode.current,
                                readingMode.current,
                                methodOld,
                                extension.current
                            );
                        }}
                    />
                    <Button 
                        text={t("buttons.download")} 
                        color={"green"} 
                        icon={<ImageIcon className={"icon"} src={Download} fill={(((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45) ? "disabled" : "green"}/>} 
                        width={'220px'} 
                        disabled={(((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45)}
                        onClick={() => {
                            const startDate = `${new Date(datainicio).toISOString().slice(0, 10)}T00:00`;
                            const endDate = `${new Date(datafim).toISOString().slice(0, 10)}T23:59:59`;
                            const methodOld = method.current === 'legacy';
                            
                            services.current.getExcel(
                                id,
                                startDate,
                                endDate,
                                analysisMode.current,
                                readingMode.current,
                                methodOld,
                                extension.current
                            );
                        }}
                    />
                </ButtonsContainer>
                {((new Date(datafim) - new Date(datainicio)) / (1000 * 60 * 60 * 24)) > 45 && (selectedMethod !== downloadMethods[0].id) &&
                    <WarningText>
                        *{t("modal.report.warnings.long-period")}
                    </WarningText>
                }
            </Modal>
        </>
    );
}

export default HistoricOnlyAnalysis;
